import { LIVE_CHAT_MODES } from "../constants";

function safeStorage(storage) {
  try {
    const key = "__pragma_live_chat_probe__";
    storage.setItem(key, key);
    storage.removeItem(key);
    return storage;
  } catch {
    return null;
  }
}

export function createLiveChatStorage({ merchantId, domain, mode }) {
  const identity = merchantId || domain || "unknown";
  const namespace = `pragma:live-chat:${mode || LIVE_CHAT_MODES.public}:${identity}`;
  const persistent = safeStorage(window.localStorage);
  const session = safeStorage(window.sessionStorage);
  const keys = {
    visitor: `${namespace}:visitor`,
    token: `${namespace}:token`,
    pending: `${namespace}:pending`,
  };

  const readJson = (storage, key, fallback) => {
    try {
      return JSON.parse(storage?.getItem(key)) ?? fallback;
    } catch {
      return fallback;
    }
  };

  return {
    namespace,
    visitorKey: keys.visitor,
    readVisitor: () => readJson(persistent, keys.visitor, null),
    writeVisitor: (visitor) => persistent?.setItem(keys.visitor, JSON.stringify(visitor)),
    clearVisitor: () => persistent?.removeItem(keys.visitor),
    readToken: () => session?.getItem(keys.token) || null,
    writeToken: (token) => token && session?.setItem(keys.token, token),
    clearToken: () => session?.removeItem(keys.token),
    readPending: () => readJson(persistent, keys.pending, []),
    writePending: (messages) => {
      if (messages.length) persistent?.setItem(keys.pending, JSON.stringify(messages));
      else persistent?.removeItem(keys.pending);
    },
  };
}

export function createVisitorId() {
  if (window.crypto?.randomUUID) return `web-${window.crypto.randomUUID()}`;
  return `web-${Date.now()}-${Math.random().toString(16).slice(2)}`;
}

export function createClientMessageId() {
  if (window.crypto?.randomUUID) return window.crypto.randomUUID();
  return `${Date.now()}-${Math.random().toString(16).slice(2)}`;
}

